'use client';

/**
 * Sales Page Client Component
 *
 * Client component that handles the interactive HTML rendering with modals.
 * Separated from the server component to allow passing functions as props.
 */

import React from 'react';

import { InteractiveHtmlRenderer } from '../../page/components/InteractiveHtml';

import { SalesPageModalRenderer } from './SalesPageModalRenderer';

interface SalesPageClientProps {
  htmlContent: string;
}

export const SalesPageClient: React.FC<SalesPageClientProps> = ({ htmlContent }) => {
  return (
    <div className="sales-page">
      <InteractiveHtmlRenderer
        content={htmlContent}
        renderModal={(config, close) => (
          <SalesPageModalRenderer config={config} close={close} />
        )}
      />
    </div>
  );
};
